export default __webpack_public_path__ + "static/media/login-background.4369f4a4.jpg";